import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { getSonarNavig8, replySonarNavig8 } from '../../redux/sonar/sonarActions';
import Navig8Form from './components/navig8-from/Navig8Form';
import Navig8Messages from './components/navig8-messages/Navig8Messages';

import scss from './Navig8.module.scss';

function Navig8() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const dateRanges = useSelector((state) => state.sonarDashboard.dateRanges);
  const thread = useSelector((state) => state.sonarDashboard.navig8.thread);
  const navig8AbortController = useSelector((state) => state.sonarDashboard.navig8AbortController);

  const handleReply = ({ reply }) => {
    dispatch(replySonarNavig8({ reply }));
  };

  useEffect(() => {
    if (!thread && !navig8AbortController) {
      dispatch(getSonarNavig8(id));
    }
  }, [dispatch, thread, dateRanges]);

  return (
    <div className={scss.wrapper}>
      <Navig8Form onReply={handleReply} />

      <Navig8Messages />
    </div>
  );
}

export default Navig8;
